import Cookies from "js-cookie";

export const MERCHANT_COOKIE_KEY = "merchantname";

/**
 * When the app opens on a deep link (e.g. /DEV_MERCHANT/product-detail/1290), the
 * `merchantname` cookie is often still unset because route effects run after the first
 * menu API call. Use the first path segment as MID and persist it to the cookie.
 */
export function merchantSlugFromPathname(): string {
  try {
    const seg = window.location.pathname.split("/").filter(Boolean)[0] ?? "";
    if (!seg) return "";
    const lower = seg.toLowerCase();
    const reserved = new Set([
      "login",
      "signup",
      "cart",
      "checkout",
      "userdetails",
    ]);
    if (reserved.has(lower)) return "";
    if (lower.startsWith("account")) return "";
    return seg;
  } catch {
    return "";
  }
}

export function resolveMerchantMid(): string {
  const fromCookie = Cookies.get(MERCHANT_COOKIE_KEY)?.trim();
  if (fromCookie) return fromCookie;
  const fromPath = merchantSlugFromPathname();
  if (fromPath) {
    Cookies.set(MERCHANT_COOKIE_KEY, fromPath);
    return fromPath;
  }
  return "";
}
